// SemesterService.js

import axios from 'axios';
import { URL } from "../config";
const BASE_URL = URL;

const semesterService = {
  getSemesters: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/semesters/list`);
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching semesters: ${error.message}`);
    }
  },

  createSemester: async (semesterData) => {
    try {
      const response = await axios.post(`${BASE_URL}/semesters/`, {
        ...semesterData,
        isActive: false,
      });
      return response.data;
    } catch (error) {
      throw new Error(`Error creating semester: ${error.message}`);
    }
  },

  updateSemester: async (semesterId, semesterData) => {
    try {
      const response = await axios.put(`${BASE_URL}/semesters/${semesterId}`, semesterData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating semester: ${error.message}`);
    }
  },

  importVolunteers: async (semesterId, userIds) => {
    try {
      const response = await axios.post(`${BASE_URL}/semesters/${semesterId}/import-volunteers`, { userIds });
      return response.data;
    } catch (error) {
      throw new Error(`Error importing volunteers: ${error.message}`);
    }
  },

  setActiveSemester: async (semesterId) => {
    try {
      const response = await axios.put(`${BASE_URL}/semesters/${semesterId}/active`);
      return response.data;
    } catch (error) {
      throw new Error(`Error activating semester: ${error.message}`);
    }
  },

  deleteSemester: async (semesterId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/semesters/${semesterId}`);
      return response.data;
    } catch (error) {
      // Surface the backend's specific reason (e.g. blocked by existing events/open calls)
      const message = error.response?.data?.error || `Error deleting semester: ${error.message}`;
      throw new Error(message);
    }
  },

  getLockedVolunteers: async (semesterId) => {
    try {
      const response = await axios.get(`${BASE_URL}/semesters/${semesterId}/organizers`);
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching locked volunteers: ${error.message}`);
    }
  },

  updateSemesterVolunteers: async (semesterId, userIds) => {
    try {
      const response = await axios.put(`${BASE_URL}/semesters/${semesterId}/volunteers`, { userIds });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || `Error updating semester volunteers: ${error.message}`;
      throw new Error(message);
    }
  },
};

export default semesterService;
